import FeedbackService from './feedback.service';

export default {};

export const upload = async (text) => {
  const { data } = await FeedbackService.upload(text);
  return data;
};
